import React from 'react';

const ShippingPolicy = () => {
  const headingStyle = {
    fontSize: '3rem',
    fontWeight: '500',
    margin: '20px 0 10px 0',
    color:'#44413e'
  };

  const bulletPointStyle = {
    lineHeight: '1.6',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'flex-start',
    marginLeft:"2rem"
  };

  const bulletSymbolStyle = {
    marginRight: '10px',
    fontSize: '30px',
    // lineHeight: '1.5',
    marginTop:'-1.2rem'
  };

  return (
    <div style={{padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop:'10rem' }}>
      <div style={headingStyle}>Shipping Policy</div>

      <p style={bulletPointStyle}>
        <span style={bulletSymbolStyle}>•</span>
        <span>We at <strong>Kidrise</strong> ship our products pan India.</span>
      </p>

      <p style={bulletPointStyle}>
        <span style={bulletSymbolStyle}>•</span>
        <span>A shipping charge of <strong>₹99/-</strong> will be applicable on orders below <strong>₹299/-</strong>, and for Cash On Delivery orders, pay extra <strong>₹69/-</strong>.</span>
      </p>

      <p style={bulletPointStyle}>
        <span style={bulletSymbolStyle}>•</span>
        <span>Orders above <strong>₹3000/-</strong> will be accepted on <strong>prepaid payments</strong> only.</span>
      </p>

      <p style={bulletPointStyle}>
        <span style={bulletSymbolStyle}>•</span>
        <span>Orders placed after <strong>Saturday 5:00 PM</strong> will be processed for shipment only on the following <strong>Mondays</strong> or upcoming working days.</span>
      </p>

      <p style={bulletPointStyle}>
        <span style={bulletSymbolStyle}>•</span>
        <span>The estimated delivery time may vary slightly from <strong>State to State</strong> & <strong>Metro to Non-Metro City</strong>. Days are calculated as working days, excluding <strong>Sundays & Holidays</strong>.</span>
      </p>
    </div>
  );
};

export default ShippingPolicy;
